import { RouteConfig } from 'vue-router'
import { CreateRouterOptions } from '@/typings/common'

import { authSessionPermissions as Permissions } from '@/helpers/enums/permission-models'
import { SESSIONS_ROUTES as ROUTES } from './utils'


type Options = Required<CreateRouterOptions>
type PromiseVue = Promise<typeof import('*.vue')>

export { MENU as MENU_SESSIONS } from './utils'

const createRoutes = (options: Options): RouteConfig[] => [
  {
    path: 'sessions',
    name: ROUTES.LAYOUT,
    redirect: { name: ROUTES.LIST },
    meta: { authorized: true },
    async beforeEnter(to, from, next) {
      const { registerModule } = await import(
        /* webpackChunkName: "sessions.store" */
        './store'
      )
      registerModule(options)
      next()
    },
    component: {
      name: 'view-sessions-layout',
      render: (h) => h('router-view'),
    },
    children: [
      {
        path: '',
        name: ROUTES.LIST,
        meta: {
          permission: Permissions.read,
        },
        component: (): PromiseVue => import(
          /* webpackChunkName: "sessions.list" */
          './SessionsList.vue'
        ),
      },
    ],
  },
]

const createModule = (options: Options): RouteConfig[] => {
  const routes = createRoutes(options)
  return routes
}

export default createModule
